import { ConnectorsPage as ConnectorsPageInner } from '@/features/connectors/ConnectorsPage';

export function ConnectorsPage() {
  return <ConnectorsPageInner />;
}
